import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { KiosModeDialog } from '../dialogs/kios-mode/kios-mode.dialog';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class Kios {
    private kiosDialog: MatDialogRef<KiosModeDialog>;

    constructor(
        private dialog: MatDialog,
        private router: Router
    ) {
        if (localStorage.getItem('kioskMode') === null) {
            localStorage.setItem('kioskMode', 'false');
        }
    }

    openKiosWindow() {
        this.kiosDialog = this.dialog.open(KiosModeDialog, {
            autoFocus: false,
            width: '100vw',
            height: '100vh',
            maxWidth: '100vw',
            panelClass: 'kios'
        });
    }

    isKioskMode(): boolean {
        return localStorage.getItem('kioskMode') === 'true';
    }

    enterKiosMode() {
        localStorage.setItem('kioskMode', 'true');

        this.openKiosWindow();
        //this.enterFullscreen();
        this.router.navigate(['kiosk']);

    }
    
    exitKioskMode() {
        localStorage.removeItem('kioskMode');

        this.kiosDialog.close();
    }

    private enterFullscreen(): void {
        const elem = document.documentElement;
        if (elem.requestFullscreen) {
            elem.requestFullscreen();
        } else if ((<any>elem).webkitRequestFullscreen) {
            (<any>elem).webkitRequestFullscreen(); // Safari
        } else if ((<any>elem).msRequestFullscreen) {
            (<any>elem).msRequestFullscreen(); // IE11
        }
    }
}
